import Missing from "../../../Missing";
import Header from "../../../../components/common/Header";
import Icon from "../../../../components/common/Icon";
import useDeceased from "../../../../hooks/useDeceased";
import {getDeceasedInfos} from "../../../../api/pro/deceasedReq";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import useAuth from "../../../../hooks/useAuth";
import {useEffect, useRef, useState} from "react";
import {
    deleteFprFileFromDb,
    getFprContentList,
    getFprDecesDataSaved,
    getFprDecesInfoDecesList,
    getFprDecesIntervenantList,
    getFprDecesTemplateList, getFprFile,
    getFprPrint,
    getFprSymbolList,
    getIntroductionTextList,
    saveFprData,
    saveTemplate, uploadFprPdf
} from "../../../../api/pro/fprReq";
import { getEventList, getEventListInfos } from "../../../../api/pro/eventReq";
import FprBreadCrumbs from "./FprBreadCrumbs";
import FormEditFprContent from "../../../../forms/deceased/FormEditFprContent";
import {adaptFprGenderText, fileToBase64, getErrorListFromValidation, getFprEventDefaultContent, processFprTextEquivalences, removeErrorList} from "../../../../helper/tools";
import {PDFViewer} from "@react-pdf/renderer";
import {safeJwtDecode} from "../../../../helper/jwtHelper";

export default function FairePartDeces({ tab : initialTab }) {
    const { deceasedInfos, setDeceasedInfos, eventList, setEventList } = useDeceased();
    const { id } = useParams();
    const { auth } = useAuth();
    const token = auth.token;
    const decodedToken = safeJwtDecode(token);
    const agencyId = decodedToken?.agency;
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [ fprDecesTemplateList, setFprDecesTemplateList ] = useState();
    const IMG_FOLDER = process.env.REACT_APP_LOCAL_ASSETS_BASE_URL;
    const [ fprDataSaved, setFprDataSaved ] = useState();
    const [ fprDataContentSaved, setFprDataContentSaved ] = useState();
    const [ showEditContentModal, setShowEditContentModal ] = useState(false);
    const [ contentType, setContentType ] = useState();
    const [ selectedTemplate, setSelectedTemplate ] = useState();
    const [ savedTemplate, setSavedTemplate ] = useState();
    const [ tab, setTab ] = useState(initialTab);
    const [ selectedPhoto, setSelectedPhoto ] = useState();
    const [ fileName, setFileName ] = useState();
    const [ fprFile, setFprFile ] = useState();
    const [ fprPdfFile, setFprPdfFile ] = useState();
    const [ uploadSuccess, setUploadSuccess ] = useState(false);
    const [ apercuPdfUrl, setApercuPdfUrl ] = useState();
    const [ apercuLoading, setApercuLoading ] = useState(false);

    const apiDeceasedInfos = async () => {
        const response = await getDeceasedInfos(token, id)
        setDeceasedInfos(response)
    }

    const apiEventList = async () => {
        const response = await getEventList(token, id)
        setEventList(Array.isArray(response) ? response : [])
    }

    const apiFprFile = async () => {
        const response = await getFprFile(token, id, "1")
        if (response?.error) {
            return;
        } else {
            setFprFile(response)
        }
    }

    const handleChangeFormat = async (template) => {
        if (id && template?.id) {
            await saveTemplate(token, {
                deceasedId: id,
                typeFpr: 1,
                templateId: template.id
            })
        }
        setSelectedTemplate(template)

        // Pré-remplir dès le clic sur un thème (avant même de valider "Suivant") afin que
        // l'aperçu affiché en step 1 montre un vrai contenu et non une page quasi vide.
        // Se relance à chaque changement de template : prefillDefaultFprContent ne complète
        // que les rubriques encore vides (voir alreadyFilled), sans écraser le contenu déjà
        // rempli manuellement — nécessaire car le symbole/la photo par défaut dépendent du
        // template choisi (ex: passer de "Photo" à "Symbole" doit préremplir le symbole,
        // qui n'a pas pu l'être lors du premier clic sur "Photo").
        prefillDefaultFprContent(template);
    }

    const apiFprDataSaved = async () => {
        const response = await getFprDecesDataSaved(token, id)
        setFprDataContentSaved(response['dataSaved'])
        setFprDataSaved(response)
    }

    const apiFprDecesTemplateList = async () => {
        const response = await getFprDecesTemplateList(token)
        setFprDecesTemplateList(response)
    }

    useEffect(() => {
        apiFprDecesTemplateList()
    }, [ token ]);

    useEffect(() => {
        apiFprDataSaved()
        apiDeceasedInfos()
        apiEventList()
        apiFprFile()
    }, [ id ]);

    useEffect(() => {
        apiFprFile()
    }, [ fprPdfFile ]);

    useEffect(() => {
        if (fprDataContentSaved) {
            const fprTemplate = fprDecesTemplateList?.find(template => template.id == fprDataContentSaved?.['form-template'])
            setSelectedTemplate(fprTemplate)

            if (fprTemplate) {
                prefillDefaultFprContent(fprTemplate)
            }
        }
    }, [ fprDataContentSaved, fprDecesTemplateList ]);

    useEffect(() => {
        if (selectedTemplate) {
            apiApercuPdf()
        }
    }, [ fprDataContentSaved, selectedTemplate ]);

    const handleClickButton = (e) => {
        let myContentType = e.target.nextSibling.textContent
        if (myContentType) {
            setContentType(myContentType)
            setShowEditContentModal(true)
        }
    }

    const handleRemoveEditContentModal = (e) => {
        if (e.target.classList.contains("edit-content")) {
            setShowEditContentModal(false)
        }
    }

    const apiUploadedFile = async() => {
        if (fprPdfFile) {
            let fileName = "fprPdf.pdf";
            let pdfId = fprFile?.id ? fprFile?.id : 0;
            const formData = new FormData();
            formData.append('file', fprPdfFile);
            formData.append('file_name', fileName);
            formData.append('deceasedId', id);
            formData.append('agencyId', agencyId);
            formData.append('id', pdfId);
            formData.append('type', "1");
            const response = await uploadFprPdf(token, formData)
                .then((response) => {
                    removeErrorList();
                    if (response?.response?.data?.error) {
                        getErrorListFromValidation(response?.response?.data?.error)
                        return false;
                    }
                    return true;
                })
            return response;
        }
    };

    const handleUploadFilePdf = async () => {
        if (fprPdfFile) {
            const success = await apiUploadedFile()
            if (success) {
                setUploadSuccess(true)
                await apiFprFile()
            }
        }
    }

    const handleValidateFprPdf = () => {
        navigate(`/defunt/${id}`)
    }

    const handlePrintFpr = () => {
        if (id) {
            getFprPrint(token, id, 1)
                .then(response => {
                    if (response instanceof Blob && response.type === 'text/html') {
                        response.text().then(downloadUrl => {
                            const pdfLink = document.createElement('a');
                            pdfLink.href = downloadUrl;
                            pdfLink.target = '_blank';
                            pdfLink.setAttribute('download', `fpr_deces_${deceasedInfos?.lastName}_${deceasedInfos?.firstName}.pdf`);
                            document.body.appendChild(pdfLink);
                            pdfLink.click();
                            document.body.removeChild(pdfLink);
                        })
                    }
                })
        }
    }

    const apercuRequestIdRef = useRef(0);
    const apiApercuPdf = () => {
        if (!id) return;
        const requestId = ++apercuRequestIdRef.current;
        setApercuLoading(true);
        getFprPrint(token, id, 1)
            .then(response => {
                if (requestId !== apercuRequestIdRef.current) return;
                if (response instanceof Blob && response.type === 'text/html') {
                    response.text().then(downloadUrl => {
                        if (requestId !== apercuRequestIdRef.current) return;
                        setApercuPdfUrl(`${downloadUrl}?t=${Date.now()}`);
                        setApercuLoading(false);
                    })
                } else {
                    setApercuLoading(false);
                }
            })
            .catch(() => {
                if (requestId === apercuRequestIdRef.current) setApercuLoading(false);
            });
    }

    // zoom=100 pour afficher la page à taille réelle, sans recadrage automatique.
    const getApercuUrl = () => {
        if (!apercuPdfUrl) return apercuPdfUrl;
        return `${apercuPdfUrl}#zoom=100`;
    }

    // Pré-remplit chaque rubrique avec la première formule de sa liste, pour ne pas arriver
    // sur un faire-part totalement vide dès le choix du thème.
    // Correspondance entre le "contentType" envoyé à saveFprData et la clé sous laquelle
    // la rubrique est stockée dans fprDataContentSaved (voir FPRTemplateController::saveFprData).
    const fprContentTypeToKey = {
        "epitaphes": "form-modalEpitaphe",
        "symboles": "form-symbole",
        "intervenants": "form-modalIntervenant",
        "formule d'introduction": "form-modalIntro",
        "information décès": "form-modalInfoDecease",
        "information cérémonie": "form-modalInfoCeremoy",
        "information recueillement": "form-modalInfoReceuillement",
        "information verre du souvenir": "form-modalInfoDrink",
        "adresse de correspondance": "form-modalAdressCorres",
    };
    const isFprContentAlreadyFilled = (contentType) => !!fprDataContentSaved?.[fprContentTypeToKey[contentType]];

    const prefillDefaultFprContent = async (template) => {
        console.log("prefillDefaultFprContent : démarrage, template =", template);
        const firstOf = (list) => (Array.isArray(list) && list.length > 0) ? list[0] : null;
        const sections = [];

        if (!isFprContentAlreadyFilled("epitaphes")) {
            const epitapheList = await getFprContentList(token, 1);
            const firstEpitaphe = firstOf(processFprTextEquivalences(Array.isArray(epitapheList) ? epitapheList : [], deceasedInfos));
            if (firstEpitaphe?.text) {
                sections.push({ contentType: "epitaphes", content: firstEpitaphe.text });
            }
        }

        if (template?.symbole && !isFprContentAlreadyFilled("symboles")) {
            const symbolList = await getFprSymbolList(token);
            const firstSymbol = firstOf(symbolList);
            if (firstSymbol?.url) {
                sections.push({ contentType: "symboles", content: firstSymbol.url });
            }
        }

        if (!isFprContentAlreadyFilled("intervenants")) {
            const intervenantList = await getFprDecesIntervenantList(token, id);
            const firstIntervenant = firstOf(intervenantList);
            if (firstIntervenant?.text) {
                sections.push({ contentType: "intervenants", content: firstIntervenant.text });
            }
        }

        if (!isFprContentAlreadyFilled("formule d'introduction")) {
            const introList = await getIntroductionTextList(token, 4, 3);
            const firstIntro = firstOf(processFprTextEquivalences(Array.isArray(introList) ? introList : [], deceasedInfos));
            const firstIntroContent = firstIntro?.formules || firstIntro?.text;
            if (firstIntroContent) {
                sections.push({ contentType: "formule d'introduction", content: firstIntroContent });
            }
        }

        if (!isFprContentAlreadyFilled("information décès")) {
            const infoDecesList = await getFprDecesInfoDecesList(token, id);
            const firstInfoDeces = firstOf(infoDecesList);
            if (firstInfoDeces?.text) {
                sections.push({ contentType: "information décès", content: adaptFprGenderText(firstInfoDeces.text, deceasedInfos) });
            }
        }

        try {
            const deceasedEventInfos = await getEventListInfos(token, id);
            const eventDefaultContentParams = { eventList, deceasedInfos, deceasedEventInfos };

            if (!isFprContentAlreadyFilled("information cérémonie") && eventList?.some(event => ["Ceremonie", "Cremation", "Obseques"].includes(event?.typeKey))) {
                const ceremonyContent = getFprEventDefaultContent('Information cérémonie', eventDefaultContentParams);
                if (ceremonyContent) {
                    sections.push({ contentType: "information cérémonie", content: ceremonyContent });
                }
            }

            if (!isFprContentAlreadyFilled("information recueillement") && eventList?.some(event => event?.typeKey === "Recueillement")) {
                const recueillementContent = getFprEventDefaultContent('Information recueillement', eventDefaultContentParams);
                if (recueillementContent) {
                    sections.push({ contentType: "information recueillement", content: recueillementContent });
                }
            }

            if (!isFprContentAlreadyFilled("information verre du souvenir") && eventList?.some(event => event?.typeKey === "VinHonneur")) {
                const drinkContent = getFprEventDefaultContent('Information verre du souvenir', eventDefaultContentParams);
                if (drinkContent) {
                    sections.push({ contentType: "information verre du souvenir", content: drinkContent });
                }
            }
        } catch (error) {
            console.error("prefillDefaultFprContent : erreur lors du calcul des rubriques événementielles :", error);
        }

        // Ne dépend que de deceasedInfos (pas des événements) : hors du try/catch ci-dessus pour
        // rester rempli même si la récupération des infos d'événements échoue.
        if (!isFprContentAlreadyFilled("adresse de correspondance")) {
            const addressContent = getFprEventDefaultContent('Adresse de correspondance', { eventList, deceasedInfos, deceasedEventInfos: null });
            if (addressContent) {
                sections.push({ contentType: "adresse de correspondance", content: addressContent });
            }
        }

        for (const section of sections) {
            const response = await saveFprData(token, {
                deceasedId: id,
                typeFpr: "1",
                content: section.content,
                contentType: section.contentType,
                ...(section.fileName ? { fileName: section.fileName } : {})
            });
            if (response?.response?.data?.error) {
                console.error(`Erreur lors du pré-remplissage de "${section.contentType}" :`, response.response.data.error);
            }
        }

        if (sections.length > 0) {
            apiFprDataSaved();
        }
    }

    const handleMNext = () => {
        let body = {
            deceasedId: id,
            typeFpr: 1,
            templateId: selectedTemplate?.id
        }
        saveTemplate(token, body)
            .then(() => {
                setSavedTemplate(fprDecesTemplateList?.find(template => template.id === selectedTemplate?.id))
                setTab("donnees")
            apiFprFile()
            apiFprDataSaved()
        })
    }

    const handleMPrev = () => {
        if (tab === "modifier") {
            navigate(`/defunt/${id}`)
        }
    }

    const handleBack = () => {
        navigate(`/defunt/${id}`)
    }

    const handleDNext = () => {
        if (savedTemplate) {
            if (savedTemplate?.photo) {
                setTab("photo")
            } else {
                setTab("finaliser")
            }
        } else {
            setTab("modifier")
        }
    }

    const handleDPrev = () => {
        setTab("modifier")
    }

    const handlePPrev = () => {
        if (savedTemplate) {
            setTab("donnees")
        } else {
            setTab("modifier")
        }
    }

    const handleFPrev = () => {
        if (savedTemplate) {
            if (savedTemplate.photo) {
                setTab("photo")
            } else {
                setTab("donnees")
            }
        } else {
            setTab("modifier")
        }
    }

    const handleChangeFprFile = async (e) => {
        let fprFile = e.target.files[0]
        if (e) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFprPdfFile(reader.result)
            }
            reader.readAsDataURL(fprFile)
            try {
                const base64FprFile = await fileToBase64(fprFile);
                setFprPdfFile(base64FprFile)
            } catch (error) {
                console.error("Erreur lors de la conversion en base64 : ", error);
            }
        }
    }

    const handleChangePhoto = async (e) => {
        let photo = e.target.files[0]
        if (e) {
            setFileName(e.target.value)
            const reader = new FileReader();
            reader.onloadend = () => {
                setSelectedPhoto(reader.result)
            }
            reader.readAsDataURL(photo)
            try {
                const base64Photo = await fileToBase64(photo);
                setSelectedPhoto(base64Photo)
            } catch (error) {
                console.error("Erreur lors de la conversion en base64 : ", error);
            }
        }
    }

    const handleDeleteFprFile = async () => {
        if (fprFile?.id) {
            const response = await deleteFprFileFromDb(token, fprFile?.id)
            if (!response?.response?.data?.error) {
                setFprFile(null)
                setFprPdfFile(null)
            }
        }
    }

    const handlePNext = async () => {
        let body = {
            deceasedId: id,
            fileName : fileName,
            typeFpr: 1,
            content: selectedPhoto,
            contentType: "photo"
        }
        await saveFprData(token, body)
            .then(() => {
                apiFprDataSaved()
                setTab("finaliser")
            })
    }



    return (
        <main>
            {fprDecesTemplateList?.error &&
                <Missing />
            }
            { !fprDecesTemplateList?.error &&
                <>
                    <Header
                        location="Espace de gestion des faire-part de décès pour "
                        locationComp={`
                            ${deceasedInfos?.lastName} 
                            ${deceasedInfos?.firstName}
                        `}
                        parent="Défunt"
                        slug={`/defunt/${deceasedInfos?.id}`}
                    />
                    { showEditContentModal &&
                        <div className="modal edit-content">
                            <FormEditFprContent
                                typeFpr="1"
                                fprDataContentSaved={fprDataContentSaved}
                                apiFprDataSaved={apiFprDataSaved}
                                selectedTemplate={selectedTemplate}
                                setShowModal={setShowEditContentModal}
                                contentType={contentType}
                            />
                        </div>
                    }
                        { !pathname?.includes("voir-fichier") &&
                            <>
                                {!pathname.includes("fichier") && <FprBreadCrumbs fprDataSaved={fprDataSaved} tab={tab} setTab={setTab} selectedTemplate={savedTemplate} location="fpr-deces" />}
                                <div className="double-fieldset">
                                    { tab === "modifier" &&
                                        <fieldset className="fpr-templates">
                                            <h3>Choisissez le thème de votre faire-part</h3>
                                            <div className="flex evenly">
                                                { fprDecesTemplateList?.map((template, index) => (
                                                    <div
                                                        key={index}
                                                        className={`fpr-template-card ${selectedTemplate?.id === template.id ? 'selected' : ''}`}
                                                        onClick={() => handleChangeFormat(template)}
                                                    >
                                                        <div className="fpr-template-label">
                                                            <span>{template.name}</span>
                                                        </div>
                                                        <div className="fpr-template-preview">
                                                            <img className="miniature" src={`${IMG_FOLDER}/img/fpr/symboles-miniature/${template.nameminiaturefile}`} alt={template.title} />
                                                        </div>
                                                        {selectedTemplate?.id === template.id && (
                                                            <div className="fpr-template-selected-badge">
                                                                <i className="fa fa-check-circle"></i>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="fpr-buttons">
                                                <div className="buttons-container">
                                                    <button type="button" className="fpr-back-to-deceased-button" onClick={handleBack}><i
                                                        className="fa fa-arrow-left"></i><span>Retour</span>
                                                    </button>
                                                    {tab != "modifier" && <button type="button" className="red-button" onClick={handleMPrev}><i
                                                        className="fa fa-times"></i><span>Etape précédente</span>
                                                    </button>}
                                                    { selectedTemplate && <button type="button" className="long green-button" onClick={handleMNext}><i
                                                        className="fa fa-check"></i><span>Valider et passer à l'étape suivante</span>
                                                    </button>}
                                                </div>
                                            </div>
                                        </fieldset>
                                    }
                                    { tab === "donnees" &&
                                        <fieldset>
                                            <div className="fpr-buttons">
                                                <div id="button-1" className="flex">{fprDataContentSaved?.['form-modalEpitaphe'] ? <button onClick={handleClickButton} className="blue-button"><span>Modifier</span></button> : <button onClick={handleClickButton} className="green-button"><span>Créer</span></button>}<span>Epitaphes</span></div>
                                                {savedTemplate?.symbole && <div id="button-symbole" className="flex">{fprDataContentSaved?.['form-symbole'] ? <button onClick={handleClickButton} className="blue-button"><span>Modifier</span></button> : <button onClick={handleClickButton}  className="green-button"><span>Créer</span></button>}<span>Symboles</span></div>}
                                                <div id="button-2" className="flex">{fprDataContentSaved?.['form-modalIntervenant'] ? <button onClick={handleClickButton} className="blue-button"><span>Modifier</span></button> : <button onClick={handleClickButton} className="green-button"><span>Créer</span></button>}<span>Intervenants</span></div>
                                                <div id="button-3" className="flex">{fprDataContentSaved?.['form-modalIntro'] ? <button onClick={handleClickButton} className="blue-button"><span>Modifier</span></button> : <button onClick={handleClickButton} className="green-button"><span>Créer</span></button>}<span>Formule d'introduction</span></div>
                                                <div id="button-4" className="flex">{(fprDataContentSaved && fprDataContentSaved?.['form-modalInfoDecease'] !== "") ? <button onClick={handleClickButton} className="blue-button"><span>Modifier</span></button> : <button onClick={handleClickButton} className="green-button">Créer</button>}<span>Information décès</span></div>
                                                {eventList?.some(event => ["Ceremonie", "Cremation", "Obseques"].includes(event?.typeKey)) &&
                                                    <div id="button-5" className="flex">{fprDataContentSaved?.['form-modalInfoCeremoy'] ? <button onClick={handleClickButton} className="blue-button"><span>Modifier</span></button> : <button onClick={handleClickButton} className="green-button"><span>Créer</span></button>}<span>Information cérémonie</span></div>
                                                }
                                                {eventList?.some(event => event?.typeKey === "Recueillement") &&
                                                    <div id="button-6" className="flex">{fprDataContentSaved?.['form-modalInfoReceuillement'] ? <button onClick={handleClickButton} className="blue-button"><span>Modifier</span></button> : <button onClick={handleClickButton} className="green-button"><span>Créer</span></button>}<span>Information recueillement</span></div>
                                                }
                                                {eventList?.some(event => event?.typeKey === "VinHonneur") &&
                                                    <div id="button-7" className="flex">{fprDataContentSaved?.['form-modalInfoDrink'] ? <button onClick={handleClickButton} className="blue-button"><span>Modifier</span></button> : <button onClick={handleClickButton} className="green-button"><span>Créer</span></button>}<span>Information verre du souvenir</span></div>
                                                }
                                                <div id="button-8" className="flex">{fprDataContentSaved?.['form-modalAdressCorres'] ? <button onClick={handleClickButton} className="blue-button"><span>Modifier</span></button> : <button onClick={handleClickButton} className="green-button"><span>Créer</span></button>}<span>Adresse de correspondance</span></div>
                                            </div>
                                            <div className="fpr-buttons">
                                                <div className="buttons-container">
                                                    <button type="button" className="fpr-back-to-deceased-button" onClick={handleBack}><i
                                                        className="fa fa-arrow-left"></i><span>Retour</span>
                                                    </button>
                                                    <button type="button" className="red-button" onClick={handleDPrev}><i
                                                        className="fa fa-times"></i><span>Etape précédente</span>
                                                    </button>
                                                    <button type="button" className="long green-button" onClick={handleDNext}><i
                                                        className="fa fa-check"></i><span>Valider et passer à l'étape suivante</span>
                                                    </button>
                                                </div>
                                            </div>

                                        </fieldset>
                                    }
                                    { tab === "photo" &&
                                        <>
                                            {savedTemplate?.photo ?
                                                <fieldset>
                                                    <div className="form-input column agency-picture">
                                                        <label htmlFor="photo">Photo</label>
                                                        {selectedPhoto ?
                                                            <img src={selectedPhoto} alt="Prévisualisation"/>
                                                            : savedTemplate ?
                                                                savedTemplate?.photo &&
                                                                <img src={`${IMG_FOLDER}/img/${deceasedInfos?.uploadDir}/${(fprDataContentSaved?.['form-photo'])?.replace("/ObsequesEnFrance/web", "")}`} alt="photo du faire-part"/>
                                                                : <p>Choisissez une photo pour ce faire-part</p>
                                                        }
                                                        <input type="file" name="photo" id="photo" onChange={handleChangePhoto}/>
                                                    </div>
                                                    <div className="fpr-buttons">
                                                        <div className="buttons-container">
                                                            <button type="button" className="fpr-back-to-deceased-button" onClick={handleBack}><i
                                                                className="fa fa-arrow-left"></i><span>Retour</span>
                                                            </button>
                                                            <button type="button" className="red-button" onClick={handlePPrev}><i
                                                                className="fa fa-times"></i><span>Etape précédente</span>
                                                            </button>
                                                            <button type="button" className="long green-button" onClick={handlePNext}><i
                                                                className="fa fa-check"></i><span>Valider et passer à l'étape suivante</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                                : <fieldset>
                                                    <p>Le format de ce faire-part ne nécessite pas de photo</p>
                                                    <div className="fpr-buttons">
                                                        <div className="buttons-container">
                                                            <button type="button" className="fpr-back-to-deceased-button" onClick={handleBack}><i
                                                                className="fa fa-arrow-left"></i><span>Retour</span>
                                                            </button>
                                                            <button type="button" className="red-button" onClick={handlePPrev}><i
                                                                className="fa fa-times"></i><span>Etape précédente</span>
                                                            </button>
                                                            <button type="button" className="long green-button" onClick={handlePNext}><i
                                                                className="fa fa-check"></i><span>Valider et passer à l'étape suivante</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            }
                                        </>
                                    }
                                    {tab === "finaliser" &&
                                        <>
                                            <fieldset>
                                                <p> Vous pouvez imprimer ce faire-part directement dans
                                                    votre agence de Pompes Funèbres ou faire une demande
                                                    de devis pour le faire imprimer dans les règles de l'art
                                                    par des professionnels de l'impression
                                                </p>
                                                <div className="fpr-buttons">
                                                    <div className="buttons-container">
                                                        <button type="button" className="fpr-back-to-deceased-button" onClick={handleBack}>
                                                            <i className="fa fa-arrow-left"></i><span>Retour</span>
                                                        </button>
                                                        <button type="button" className="red-button" onClick={handleFPrev}>
                                                            <i className="fa fa-close"></i><span>Etape précédente</span>
                                                        </button>
                                                        <button onClick={handlePrintFpr} className="green-button" type="button"><i className="fa fa-print"/><span>Imprimer</span></button>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </>
                                    }
                                    { tab === "fichier" &&
                                        <>
                                            <fieldset>
                                                <p>Vous pouvez télécharger le fichier PDF de ce faire-part</p>
                                                { fprFile?.id &&
                                                    <div className="flex-buttons">
                                                        <button onClick={handleDeleteFprFile} className="red-button" type="button" ><i className="fa fa-trash"/><span>Supprimer</span></button>
                                                    </div>
                                                }
                                                <div className="flex-buttons">
                                                    <input type="file" name="fprFile" id="fprFile" accept="application/pdf" onChange={handleChangeFprFile} className="hidden"/>
                                                    <label htmlFor="fprFile" className="blue-button">
                                                        <i className="fa fa-folder-open"/>
                                                        <span>{fprPdfFile ? "Fichier sélectionné" : "Choisir un fichier"}</span>
                                                    </label>
                                                    <button className="green-button" name="fprPdf" type="button" onClick={handleUploadFilePdf}><i className="fa fa-download"/><span>Télécharger</span></button>
                                                </div>
                                                {uploadSuccess && (
                                                    <div className="flex fpr-validate-row">
                                                        <button className="blue-button" type="button" onClick={handleValidateFprPdf}>
                                                            <i className="fa fa-check"></i><span>Valider</span>
                                                        </button>
                                                    </div>
                                                )}
                                            </fieldset>
                                            <fieldset className="fpr-templates">                                            <h3>Aperçu</h3>
                                                <div className="form-input html-textarea fpr-preview-frame">
                                                    {fprPdfFile ?
                                                        <PDFViewer
                                                            width="100%"
                                                            height="100%"
                                                            src={fprPdfFile}
                                                        />: (fprFile?.id) ?
                                                            <PDFViewer
                                                                width="100%"
                                                                height="100%"
                                                                src={`${IMG_FOLDER}/media/announcement/${agencyId}/${fprFile?.['name']}`}
                                                            /> :<div className='fpr-preview-default'>
                                                                <p>Choisissez un fichier pour voir l'aperçu</p>
                                                            </div>
                                                    }
                                                </div>
                                            </fieldset>
                                        </>
                                    }

                                    { tab !== "fichier" &&
                                        <fieldset className="fpr-templates">
                                            <h3>Aperçu</h3>
                                            { !selectedTemplate ?
                                                <div className="fpr-preview-default">
                                                    <p>Choisissez un modèle pour voir l'aperçu</p>
                                                </div> :
                                                apercuLoading || !apercuPdfUrl ?
                                                    <div className="fpr-preview-default">
                                                        <p>Génération de l'aperçu...</p>
                                                    </div> :
                                                    <div className="form-input html-textarea fpr-preview-frame">
                                                        <PDFViewer width="100%" height="100%" src={getApercuUrl()}/>
                                                    </div>
                                            }
                                        </fieldset>
                                    }
                                </div>
                                {tab === "fichier" &&
                                    <div className="buttons-container back bottom-centered">
                                        <button type="button" className="fpr-back-to-deceased-button" onClick={handleBack}>
                                            <i className="fa fa-arrow-left"></i><span>Retour</span>
                                        </button>
                                    </div>
                                }
                            </>
                        }
                        {
                            pathname?.includes("voir-fichier") &&
                            <fieldset className="mini">
                                <h3>Aperçu</h3>
                                { !selectedTemplate ?
                                    <div className="fpr-preview-default">
                                        <p>Choisissez un modèle pour voir l'aperçu</p>
                                    </div> :
                                    apercuLoading || !apercuPdfUrl ?
                                        <div className="fpr-preview-default">
                                            <p>Génération de l'aperçu...</p>
                                        </div> :
                                        <div className="form-input html-textarea fpr-preview-frame">
                                            <PDFViewer width="100%" height="100%" src={getApercuUrl()}/>
                                        </div>
                                }
                            </fieldset>
                        }
                    </>
                    }

        </main>
    );
}